import { FilterConfig, SearchFilterConfig, SortingFilterConfig, ResetFilterConfig, MultiselectTypeaheadFilterConfig } from '@parashift/shared/models';
import { BusinessSectorsRegister, LocalesRegister, TagsRegister } from '@parashift/shared/services';

export const filterColumnConfigBuilder = (localesRegister: LocalesRegister,
                                          businessSectorsRegister: BusinessSectorsRegister,
                                          tagsRegister: TagsRegister): FilterConfig => {

  return {
    meta: {
      identifier: 'pdc-add-fieldset-modal'
    },
    filters: [
      {
        type: 'search',
        config: {
          label: $localize `:@@shared.filter_column.name:Name`,
          field: 'name_contains',
          autofocus: true
        }
      } as SearchFilterConfig,
      {
        type: 'search',
        config: {
          label: $localize `:@@shared.filter_column.identifier:Identifier`,
          field: 'identifier_contains'
        }
      } as SearchFilterConfig,
      {
        type: 'search',
        config: {
          label: 'ID',
          field: 'id'
        }
      } as SearchFilterConfig,
      {
        type: 'multiselect-typeahead',
        config: {
          label: $localize `:@@common.locales:Locales`,
          source: localesRegister.getFilterItems(),
          sourceField: 'key',
          field: 'locales_contain',
          icon: 'flag'
        }
      } as MultiselectTypeaheadFilterConfig,
      {
        type: 'multiselect-typeahead',
        config: {
          label: $localize `:@@common.business_sectors:Business Sectors`,
          source: businessSectorsRegister.getFilterItems(),
          sourceField: 'key',
          tagDisplay: 'tagDisplay',
          field: 'business_sectors_contain',
          icon: 'suitcase',
          sliceValue: 25
        }
      } as MultiselectTypeaheadFilterConfig,
      {
        type: 'multiselect-typeahead',
        config: {
          label: $localize `:@@common.tags:Tags`,
          source: tagsRegister.getFilterItems(),
          sourceField: 'value',
          field: 'tags_contain',
          icon: 'tag',
          sliceValue: 25
        }
      } as MultiselectTypeaheadFilterConfig,
      {
        type: 'sorting',
        config: {
          label: $localize `:@@common.sorting:Sorting`,
          options: [
            { value: 'id', label: 'ID' },
            { value: 'name', label: $localize `:@@common.name_a_z:Name (A-Z)` }
          ],
          defaultValues: {
            field: 'id',
            desc: true
          }
        }
      } as SortingFilterConfig,
      {
        type: 'reset',
        config: {
          label: $localize `:@@shared.filter_column.reset_filters:Reset Filters`
        }
      } as ResetFilterConfig
    ]
  };
};
